import { render } from "./CreateSharedNetworkForm.vue?vue&type=template&id=532502a5&scoped=true"
import script from "./CreateSharedNetworkForm.vue?vue&type=script&lang=js"
export * from "./CreateSharedNetworkForm.vue?vue&type=script&lang=js"

import "./CreateSharedNetworkForm.vue?vue&type=style&index=0&id=532502a5&lang=less&scoped=true"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532502a5"]])

export default __exports__